// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3QfEl","header":"ReportDetails_header__3xrge","title":"ReportDetails_title__29yee","left":"ReportDetails_left__1LOdy"};